import { render, staticRenderFns } from "./orderCreatePage.vue?vue&type=template&id=d42d148c&"
import script from "./orderCreatePage.vue?vue&type=script&lang=ts&"
export * from "./orderCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports